import React, { useState } from 'react';
import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { sortReverse } from '../../lib/commonFunc/commonFunc';
import { Ring } from 'react-awesome-spinners';
import SearchFCList from './SearchFCList';
import { GoSearch } from 'react-icons/go';

const Wrapper = styled.div`
  min-width: 250px;
`;

const SearchBox = styled.div`
  width: 100%;
  border: 0.5px solid ${palette.webGray[4]};
  padding: 0 1rem 0 1.3rem;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;

  & svg {
    font-size: 1.3rem;
    margin: 0 10px;
    color: ${palette.webCyan[5]};
  }
`;

const StyledInput = styled.input`
  width: 100%;
  border: none;
  height: 2.5rem;
  font-size: 1rem;

  &:focus {
    outline: none;
  }
`;

const TitleDiv = styled.div`
  margin-bottom: 1.25rem;
  display: flex;
  justify-content: space-between;
`;

// const AllUserBtn = styled.div`
//   cursor: pointer;
//   color: ${palette.webCyan[5]};
// `;

const SearchArea = styled.div`
`;

const SearchTitle = styled.h2`
  font-size: 12pt;
`;

// const Space = styled.div`
//   margin-bottom: 15px;
// `;

const LoadingBox = styled.div`
  width: 100%;
  height: 56.4vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FCClassBtnBox = styled.div`
  width: 100%;  
`;

const FCClassTopBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  padding: 10px;

  & div {
    flex: 0 0 auto;
    padding: 8px 16px;
    border: 1px solid ${palette.webGray[18]};
    color: ${palette.webGray[18]};
    border-radius: .3rem;
    text-align: center;
    font-weight: bold;
    cursor: pointer;
    font-size: .9rem;

    &.active {
      background-color: ${palette.webGray[18]};
      color: #fff;
    }
  }
`;

const FCClassBottomBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  flex-wrap: wrap;
  padding: 10px;
  padding-bottom: 0;

  & div {
    flex: 0 0 auto;
    padding: 8px 16px;
    border: 1px solid ${palette.webGray[18]};
    color: ${palette.webGray[18]};
    border-radius: .3rem;
    text-align: center;
    font-weight: bold;
    cursor: pointer;
    font-size: .9rem;
    margin-bottom: 10px;

    &.active {
      background-color: ${palette.webGray[18]};
      color: #fff;
    }
  }
`;

const SearchFC = ({
  loading,
  onChangeSearch,
  showMembers,
  searchList,
  onClickTarget,
  target,
  onChangeKeyword,
  isLockerSearch,
  isRecord,
  fcList,
  ClassificationFC,
  height,
  searchText,
  selectFCitem,
}) => {

  const [FCClass, setFCClass] = useState(0);

  let filterdList = [];

  if(FCClass == 0)
  {
      // 전체: fctype 6, 7 제외, 모든 운동 표시
      filterdList = searchList.filter(item => 
        item.fctype != 6 && item.fctype != 7
      );
  }
  else if(FCClass == 1) {
    // 유산소 기구: part == 1
    filterdList = searchList.filter(item => item.part == 1);
  }
  else if(FCClass == 11) {
    // 맨몸유산소: part == 11
    filterdList = searchList.filter(item => item.part == 11);
  }
  else if(FCClass >= 2 && FCClass <= 7) {
    // 가슴(2), 어깨(3), 팔(4), 등/허리(5), 복근(6), 하체(7)
    // 웨이트머신(fctype==3)과 프리웨이트(fctype==4) 구분 없이
    filterdList = searchList.filter(item => 
      item.part == FCClass && (item.fctype == 3 || item.fctype == 4)
    );
  }

  return (
    <Wrapper>
      <SearchArea>
        <TitleDiv>
          <SearchTitle>운동 검색</SearchTitle>
        </TitleDiv>
          <SearchBox>
            <StyledInput
              placeholder="운동명"
              onChange={onChangeKeyword}
              name="keyword"
              value={searchText}
              autoComplete="off"
              autoFocus
            />
            <GoSearch />
          </SearchBox>
          <FCClassBtnBox>
            <FCClassTopBox>
              <div className={FCClass == 1 ? "active" : ""} onClick={() => {
                setFCClass(FCClass == 1 ? 0 : 1);
              }}>유산소 기구</div>
              <div className={FCClass == 11 ? "active" : ""} onClick={() => {
                setFCClass(FCClass == 11 ? 0 : 11);
              }}>맨몸유산소</div>
              <div className={FCClass == 2 ? "active" : ""} onClick={() => {
                setFCClass(FCClass == 2 ? 0 : 2);
              }}>가슴</div>
            </FCClassTopBox>
            <FCClassBottomBox>
              <div className={FCClass == 3 ? "active" : ""} onClick={() => {
                setFCClass(FCClass == 3 ? 0 : 3);
              }}>어깨</div>
              <div className={FCClass == 5 ? "active" : ""} onClick={() => {
                setFCClass(FCClass == 5 ? 0 : 5);
              }}>등/허리</div>
              <div className={FCClass == 4 ? "active" : ""} onClick={() => {
                setFCClass(FCClass == 4 ? 0 : 4);
              }}>팔</div>
              <div className={FCClass == 6 ? "active" : ""} onClick={() => {
                setFCClass(FCClass == 6 ? 0 : 6);
              }}>복근</div>
              <div className={FCClass == 7 ? "active" : ""} onClick={() => {
                setFCClass(FCClass == 7 ? 0 : 7);
              }}>하체</div>
            </FCClassBottomBox>
          </FCClassBtnBox>
          {filterdList ? 
              <SearchFCList
                data={filterdList.sort((a,b)=>{
                    // 이름순으로 정렬
                    if (a.fcname < b.fcname) {
                        return -1
                    }
                    if (a.fcname > b.fcname) {
                        return 1
                    }
                    return 0
                })}
                onClickTarget={selectFCitem}
                height={'352px'}
                loading={loading}
                fcList={fcList}
              />
              :
              <LoadingBox>
                <Ring />
              </LoadingBox>
          }
      </SearchArea>
    </Wrapper>
  );
};

export default React.memo(SearchFC);
